import { render, staticRenderFns } from "./EightLast.vue?vue&type=template&id=0a887096&"
import script from "./EightLast.vue?vue&type=script&lang=js&"
export * from "./EightLast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports